import { Box, Img, Text } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import download from '../../../../../../assets/img/games/download.png'; 
import { ProfileContext } from '../EntirePreview';
import { ScoreContext } from '../GamePreview';
import Scrollbar from 'components/customScroll/CustomScroll';
import { jsPDF } from 'jspdf'; 
const Takeway: React.FC<{
  formData: any;
  imageSrc: any;
  getData?: any;
  data?: any;
  preloadedAssets: any;
  gameInfo: any;
  setCurrentScreenId: any;
  FeedbackcurrentPosition: any;
  setFeedbackCurrentPosition: any;
  interactionBlockArray: any;
  profileData: any;
  setFeedbackNavigateNext: any;
  feedbackList: any;
  setInterActionBlockArray: any;
  getFeedbackData: () => void;
  setCurrentQuestNo: any;
  setFirstLoading: any;
}> = ({
  formData,
  imageSrc,
  getData,
  data,
  preloadedAssets,
  gameInfo,
  setCurrentScreenId,
  FeedbackcurrentPosition,
  setFeedbackCurrentPosition,
  interactionBlockArray,
  profileData,
  getFeedbackData,
  setFeedbackNavigateNext,
  setInterActionBlockArray,
  feedbackList,
  setCurrentQuestNo,
  setFirstLoading,
}) => {
  const useData = useContext(ProfileContext);
  const [TakeAwayContentLang, setTakeAwayContentLang] = useState(null);
  const { profile, setProfile } = useContext(ScoreContext);
  const TakeAwayContentLanguage = () => {
    if (profileData?.Audiogetlanguage.length !== 0) {
      const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === formData?.gameId,
      );
      if (GameLanguageFilter.length > 0) {
        const takeAwayFiltered = GameLanguageFilter.filter(
          (key: any) => key?.fieldName === 'gameTakeawayContent',
        );
        if (takeAwayFiltered.length > 0) {
          const TakeAwayContent = takeAwayFiltered[0]?.content
            ? takeAwayFiltered[0]?.content.split('\n')
            : formData?.gameTakeawayContent.split('\n');
          setTakeAwayContentLang(TakeAwayContent);
        }
      }
    } else {
      setTakeAwayContentLang(formData?.gameTakeawayContent?.split('\n'));
    }
  };
  useEffect(() => {
    TakeAwayContentLanguage();
  }, [formData]);
const handleDownloadPDF = () => {
  if (!TakeAwayContentLang || TakeAwayContentLang.length === 0) return;

  const doc = new jsPDF({ unit: "pt" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 50;
  const marginRight = 80;

  let y = 70;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);

  const title = `${gameInfo.gameData.gameTitle} Takeaways`;
  doc.text(title, pageWidth / 2, y, { align: "center" });

  y += 35;
  doc.setFontSize(13);

  TakeAwayContentLang.forEach((rawLine:any) => {
    if (!rawLine || !rawLine.trim()) return;

    // Clean encoding
    const cleanLine = rawLine.replace(/[%æÂ]/g, "").trim();

    // Detect if <h1> exists
    const hasHeading = /<h1\s*\/?>/i.test(rawLine);

    // Split content using <h1> or newline
    const parts = cleanLine
      .split(/<h1\s*\/?>|\n/gi)
      .map((p:any) => p.trim())
      .filter(Boolean);

    // ✅ Case 1: Normal paragraph (no <h1>) → ONE bullet only
    if (!hasHeading) {
      doc.setFont("helvetica", "normal");

      const wrapped = doc.splitTextToSize(cleanLine, pageWidth - marginLeft - marginRight);

      // Page break if needed
      if (y + wrapped.length * 16 > doc.internal.pageSize.getHeight() - 40) {
        doc.addPage();
        y = 70;
      }

      // doc.text("•", marginLeft, y);
      wrapped.forEach((line:any, i:any) => {
        doc.text(line, marginLeft + 1, y + i * 16);
      });

      y += wrapped.length * 16 + 10;
      return; // 🔥 Prevents extra printing (fixes double bullet issue)
    }

    // ✅ Case 2: <h1> exists → Heading + bullet sub-points
    parts.forEach((part:any, idx:any) => {
      const isMain = idx === 0;
      const indent = isMain ? 0 : 12;
      const bulletX = marginLeft + indent;
      const textX = bulletX + (isMain ? 0 : 10);

      const wrapped = doc.splitTextToSize(part, pageWidth - textX - marginRight);

      if (y + wrapped.length * 16 > doc.internal.pageSize.getHeight() - 40) {
        doc.addPage();
        y = 70;
      }

      if (isMain) {
        doc.setFont("helvetica", "bold");
        wrapped.forEach((line:any, i:any) => doc.text(line, textX, y + i * 16));
      } else {
        doc.setFont("helvetica", "normal");
        doc.text("•", bulletX, y);
        wrapped.forEach((line:any, i:any) => doc.text(line, textX, y + i * 16));
      }

      y += wrapped.length * 16 + 6;
    });

    y += 8; // spacing
  });

  doc.save(`${gameInfo.gameData.gameTitle} Takeaways.pdf`);
};
  const previousNavigation = () => {
    useData?.setMotionEffect(true);
    const LastquestNo = parseInt(profile.currentQuest);
    setFirstLoading(false);
    setCurrentQuestNo(LastquestNo);
    setTimeout(() => {
      if (
        formData?.gameIsShowReflectionScreen === 'true' &&
        gameInfo?.reflectionQuestions.length > 0
      ) {
        setCurrentScreenId(3);
        return false;
      } else if (
        feedbackList.length !== 0 &&
        gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
      ) {
        if (
          feedbackList?.find((item: any) => item.quest == profile.currentQuest)
        ) {
          const groupedFeedback: { [key: string]: any[] } = {};
          feedbackList.forEach((feedback: any) => {
            if (!(feedback.Seq in groupedFeedback)) {
              groupedFeedback[feedback.Seq] = [];
            }
            groupedFeedback[feedback.Seq].push(feedback);
          });
          const firstPageFeedback: any[] = [];
          Object.keys(groupedFeedback).forEach((seq: any) => {
            const lastIndex = groupedFeedback[seq].length - 1;
            if (profile.currentQuest == groupedFeedback[seq][lastIndex].quest) {
              firstPageFeedback.push(groupedFeedback[seq][lastIndex]);
            }
          });
          setFeedbackCurrentPosition(firstPageFeedback.length - 1);
          setInterActionBlockArray(firstPageFeedback.length - 1);
          getFeedbackData();
          setFeedbackNavigateNext(false);
          setCurrentScreenId(14); //Navigate to together all feedback
        }
      } else if (formData?.gameIsShowLeaderboard === 'true') {
        setCurrentScreenId(4);
        return false;
      } else {
        setCurrentScreenId(6);
        return false;
      }
    }, 300);
  };
  const handleNext = () => {
    setFirstLoading(true);
    useData?.setMotionEffect(true);
    setTimeout(() => {
      getData(data);
    }, 300);
  };

  return (
    <>
      {imageSrc && (
        <Box className="takeaway-screen">
          <Box className="takeaway-screen-box">
            {formData?.gameIsShowTakeaway === 'true' ? (
              <>
                <Img src={imageSrc} className="bg-take" />
                <Box className="content-box">
                  <Scrollbar>
                    <Box>
                      {/* {TakeAwayContentLang &&
                        TakeAwayContentLang.map((it: any, ind: number) => {
                          const bulletIndex = it.indexOf('\u2022');
                          const contentAfterBullet =
                            bulletIndex !== -1
                              ? it.slice(bulletIndex + 1).trim()
                              : it;
                          return (
                            contentAfterBullet && (
                              <Box
                                className="content"
                                fontFamily={'AtlantisText'}
                                color={'#D9C7A2'}
                                key={ind}
                              >
                                <>
                                  <Img
                                    src={preloadedAssets.bull}
                                    className="dot-img"
                                    w={'16px'}
                                    h={'16px'}
                                  />
                                  {contentAfterBullet}
                                </>
                              </Box>
                            )
                          );
                        })} */}

                         {TakeAwayContentLang &&
  TakeAwayContentLang.map((it: any, ind: number) => {
    // Remove extra bullet characters if present
    const bulletIndex = it.indexOf('\u2022');
    const cleanedLine = bulletIndex !== -1 ? it.slice(bulletIndex + 1).trim() : it.trim();

    if (!cleanedLine) return null;

    // Split by <br> to separate main heading and sub-points
    const parts = cleanedLine.split('<h1>').map((p: string) => p.trim()).filter(Boolean);
    const mainHeading = parts[0];
    const subPoints = parts.slice(1);

    return (
      <Box key={ind} mb={4}>
        {/* 🔹 Main bullet heading */}
        <Box
          className="content"
          display="flex"
          alignItems="flex-start"
          fontFamily="AtlantisText"
          color="#D9C7A2"
          whiteSpace="normal"
          wordBreak="normal"
          overflowWrap="normal"
        >
          <Img
            src={preloadedAssets.bull}
            className="dot-img"
            w="16px"
            h="16px"
            mr="8px"
            mt="2px"
          />
          <Text>{mainHeading}</Text>
        </Box>

        {/* 🔸 Sub-bullets (for <br> parts) */}
        {subPoints.length > 0 && (
          <Box ml="30px" mt="4px">
            {subPoints.map((sub: string, subIndex: number) => (
              <Box
                key={subIndex}
                className="content"
          display="flex"
          alignItems="flex-start"
          fontFamily="AtlantisText"
          color="#D9C7A2"
          whiteSpace="normal"
          wordBreak="normal"
          overflowWrap="normal"
              >
                {/* <Text as="span" mr="6px">◦</Text> */}
                <Img
            src={preloadedAssets.bull}
            className="dot-img"
            w="16px"
            h="16px"
            mr="8px"
            mt="2px"
          />
                <Text as="span">{sub}</Text>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    );
  })}
                    </Box>
                  </Scrollbar>
                </Box>
                 <Box
  position="absolute"
  bottom="3%"
  right="15%"
  zIndex="10"
  className='download-mouse'
>
  <button onClick={handleDownloadPDF} className="download-btntakeaway">
    <Img
      src={download}
      alt="Download"
      w="100%"
      h={{ base: '72px', md: '90px' }} // 👈 Responsive height
    />
  </button>
</Box>

                <Box className="take-away-btns">
                  <Img
                    src={preloadedAssets.left}
                    className={'interaction_button'}
                    onClick={() => previousNavigation()}
                  />
                  <Img
                    src={preloadedAssets.right}
                    className={'interaction_button'}
                    onClick={() => handleNext()}
                  />
                </Box>
              </>
            ) : (
              <>
                <Box className="top-menu-home-section">
                  <Box className="Setting-box">
                    <Img
                      src={preloadedAssets?.Replay}
                      className="setting-pad"
                    />
                    <Box className="optional-vertex-error">
                      <Box
                        w={'100%'}
                        h={'100%'}
                        display={'flex'}
                        flexDirection={'column'}
                        justifyContent={' flex-start'}
                      >
                        <Text
                          className="No_preview"
                          textAlign={'center'}
                          mt={12}
                        >
                          The"Show Takeaway" option is currently disabled.
                          Please enable it if you want to use this feature.
                        </Text>
                        <Box
                          w={'100%'}
                          display={'flex'}
                          justifyContent={'center'}
                          position={'absolute'}
                          bottom={'0'}
                          className="left-right-btn"
                        >
                          <Box
                            w={'80%'}
                            display={'flex'}
                            justifyContent={'space-between'}
                          >
                            <Img
                              src={preloadedAssets.left}
                              className={'interaction_button'}
                              cursor={'pointer'}
                              h={'60px'}
                              onClick={() => previousNavigation()}
                            />
                            <Img
                              src={preloadedAssets.right}
                              className={'interaction_button'}
                              cursor={'pointer'}
                              h={'60px'}
                              onClick={() => getData(data)}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
export default Takeway;
